import { InfoCircleFilled } from "@ant-design/icons";
import styled from "styled-components";

export const StyledInfoCircleOutlined = styled(InfoCircleFilled)`
    font-size: 24px;
    color: ${({ theme }) => theme.colors.warning};
`;

export const StyledWarningContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 8px;
    border-radius: 8px;
    background-color: ${({ theme }) => `${theme.colors.warning}10`};
`;
